import { render } from "./MainContent.vue?vue&type=template&id=6b1a1162"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Development/lotte-deploy/cms-prod-lodash-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__